export const SET_POST_CONTACT_ERROR = 'SET_POST_CONTACT_ERROR';
export const SET_CONTACTS_LIST_ERROR = 'SET_CONTACTS_LIST_ERROR';
export const SET_CONTACTS_LIST = 'SET_CONTACTS_LIST';
export const SET_FETCHING_CONTACTS = 'SET_FETCHING_CONTACTS';
export const SET_SHOW_CONTACTS_MODAL = 'SET_SHOW_CONTACTS_MODAL';
export const SET_CONTACTS_TYPES = 'SET_CONTACTS_TYPES';
